module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/405.9247d53a.png";